<template>
  <router-link :to="link">
    <v-card class="ma-1 elevation-2 pa-0" outlined :color="color" dark>
      <v-list-item>
        <span class="text-h3 mr-2">{{ config.value }}</span>
        <v-list-item-content>
          <v-list-item-title class="text-h5 mb-1">
            {{ config.title }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ config.subtitle }}</v-list-item-subtitle>
        </v-list-item-content>
        <!-- <v-list-item-avatar
          size="80"
          color="grey"
          tile
          v-if="$vuetify.breakpoint.lgAndUp"
        >
        </v-list-item-avatar> -->
        <v-icon large>
          {{ config.icon }}
        </v-icon>
        <!-- <span class="ml-1">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z"
            />
          </svg>
        </span> -->
      </v-list-item>
      <!-- <v-card-actions>
      <slot name="action"></slot>
    </v-card-actions> -->
    </v-card>
  </router-link>
</template>

<script>
export default {
  name: "DashCard",
  props: {
    value: {
      type: Number,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    color: {
      type: String,
    },
    link: {
      type: String,
    },
    config: {
      type: Object,
    },
  },
};
</script>

<style></style>
